import { formatarData } from 'src/app/core/utils/utilities';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { LogService } from 'src/app/services/LogService/log.service';
import { IGetLogPaginetedParams } from 'src/app/services/LogService/log.model';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

@Component({
  selector: 'app-listagem-logs',
  templateUrl: './listagem-logs.component.html',
  styleUrls: ['./listagem-logs.component.scss']
})
export class ListagemLogsComponent {
  form = this.initForm();
  isLoading: boolean = false;

  numeroPagina: number = 0;
  tableData: any[] | Array<any> = [];
  paginaAtual: number = 1;
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;
  id: number = Number(localStorage.getItem('id'));

  tableColumns = [
    { header: 'Código', key: 'PK_LOGS_SIST', type: 'text' },
    { header: 'Data', key: 'DT_LOGS', type: 'text' },
    { header: 'Tipo', key: 'TX_LVEL', type: 'text' },
    { header: 'Descrição', key: 'TX_MSGS', type: 'text' },
    { header: 'Responsável', key: 'NM_FUNC', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.openModalVisualizarLog(item)
        }
      ]
    }
  ];

  constructor(
    private fb: FormBuilder,
    private logService: LogService,
    public swalAlert: SwalAlertService
  ) {}

  ngOnInit() {
    this.getLogs();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.paginaAtual = 1;
      this.getLogs();
    });
  }

  initForm(): FormGroup {
    return this.fb.group({
      DT_INIC_LOGS: [null],
      DT_TERM_LOGS: [null],
      TX_LOGS: [null]
    });
  }

  openModalVisualizarLog(item: any): void {
    let message =
      '<div style="height: 300px; overflow-y: auto; text-align: center;"><ul>';

    message += `${item.TX_MSGS}` + '<br>';

    this.swalAlert.showAlert('Alerta!', message, 'info', true, false, {
      width: '50%'
    });
  }

  getLogs(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.logService.GetLogPaginated(payload).subscribe({
      next: res => {
        this.isLoading = false;
        const data = res.ITEMS;
        if (!data) return;
        this.tableData = data.map(item => {
          return {
            PK_LOGS_SIST: this.formartTable(item.PK_LOGS_SIST),
            DT_LOGS: formatarData(item.DT_LOGS),
            TX_LVEL: this.formartTable(item.TX_LVEL),
            TX_MSGS: this.formartTable(item.TX_MSGS),
            NM_FUNC: this.formartTable(item.NM_FUNC)
          };
        });
        this.maxPages = res.TOTAL_PAGES;
      },
      error: error => {
        this.isLoading = false;
      }
    });
  }

  createPayload(): IGetLogPaginetedParams {
    return {
      DT_INIC_LOGS: this.form.value.DT_INIC_LOGS ?? '',
      DT_TERM_LOGS: this.form.value.DT_TERM_LOGS ?? '',
      TX_LOGS: this.form.value.TX_LOGS ?? '',
      PAGE_NUMBER: this.paginaAtual,
      PAGE_SIZE: 8
    };
  }

  formartTable(value: string | number | null): string {
    const invalidValue = ['', null, undefined, NaN];

    if (!value) return '---';

    if (invalidValue.includes(value)) return '---';

    return value.toString();
  }

  mudarPagina(pagina: number) {
    this.paginaAtual = pagina + 1;
    this.getLogs();
  }
}
